// Autogenerated file
export const catalogFlagsEnum = {
    ShowInMobileApp: "ShowInMobileApp",
    IsApprovedByRoot: "IsApprovedByRoot",
    ShowInEmptyMileageBids: "ShowInEmptyMileageBids",
};
export const catalogFlags = [
    { label: "Показывать в мобильном приложении", value: "ShowInMobileApp", intValue: 1 },
    { label: "Подтверждено рутом", value: "IsApprovedByRoot", intValue: 2 },
    { label: "Отображать в порожних заявках", value: "ShowInEmptyMileageBids", intValue: 4 },
];
